/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from "react";

import { ReactComponent as ChevronDownBlue } from "assets/images/iconsV2/chevron-down-brand-secondary.svg";
import { IQuotation } from "pages/shipper/ShipmentQuotes/components/quotes/QuotesType";
import QuoteDetailRouteStopListItem from "./QuoteDetailRouteStopListItem";
import { FreightModeBaseTypes } from "../../../../../../../constants";

type QuoteDetailRouteStopListProps = {
  currentQuotation: IQuotation;
};

function QuoteDetailRouteStopList(props: QuoteDetailRouteStopListProps) {
  const { currentQuotation } = props;
  const [isDetailOpen, setIsDetailOpen] = useState(false);

  const hasFlightData =
    currentQuotation?.service?.freight_mode_type === FreightModeBaseTypes.AIR &&
    currentQuotation?.schedule?.flights?.length > 0;

  const hasSailingData =
    currentQuotation?.service?.freight_mode_type === FreightModeBaseTypes.OCEAN &&
    currentQuotation?.schedule?.sailing?.departure_port &&
    currentQuotation?.schedule?.sailing?.arrival_port &&
    currentQuotation?.schedule?.sailing?.arrival &&
    currentQuotation?.schedule?.sailing?.departure;

  if (!hasFlightData && !hasSailingData) {
    return null;
  }
  return (
    <>
      {isDetailOpen && (
        <div className="route-detail-container">
          {hasFlightData &&
            currentQuotation?.schedule?.flights?.map((flight) => (
              <QuoteDetailRouteStopListItem
                portName={`${flight.airline} ${flight.flight_number}`}
                pickupPortCode={flight.departure_airport}
                pickupDateTime={flight.departure}
                deliveryPortCode={flight.arrival_airport}
                deliveryDateTime={flight.arrival}
              />
            ))}
          {hasSailingData && (
            <QuoteDetailRouteStopListItem
              portName={`${currentQuotation?.schedule?.sailing?.departure_port_name} - ${currentQuotation?.schedule?.sailing?.arrival_port_name}`}
              pickupPortCode={currentQuotation?.schedule?.sailing?.departure_port}
              pickupDateTime={currentQuotation?.schedule?.sailing?.departure}
              deliveryPortCode={currentQuotation?.schedule?.sailing?.arrival_port}
              deliveryDateTime={currentQuotation?.schedule?.sailing?.arrival}
            />
          )}
        </div>
      )}
      <div className="d-flex align-items-center cursor-pointer" onClick={() => setIsDetailOpen((prev) => !prev)}>
        <div className="text-sm font-semibold text-brand-secondary mr-sm">
          {isDetailOpen ? "Hide details" : "Show details"}
        </div>
        <ChevronDownBlue className={!isDetailOpen ? "" : "rotate-180"} style={{ transitionDuration: "500ms" }} />
      </div>
    </>
  );
}

export default QuoteDetailRouteStopList;
